import {StudentEnrollmentProps} from './types'

export const prepareStuentEnrollmentPayload = (data: StudentEnrollmentProps) => ({
  file: data.file,
  shift_id: data.shift_id,
  trip_start_time: data.trip_start_time,
  trip_end_time: data.trip_end_time,
  bus_name: data.bus_name,
  bus_number: data.bus_number,
  trip_type: data.trip_type,
})
